import { Box, makeStyles, Theme, Typography } from "@material-ui/core"
import React, { FunctionComponent } from "react"
import { GetAppRounded as GetAppRoundedIcon } from "@material-ui/icons"
import { DropzoneOptions, useDropzone } from "react-dropzone"

/** DragDropArea component props */
interface DragDropAreaProps extends DropzoneOptions {
  error?: Error | undefined
  dragActiveText?: string
  dragInactiveText?: string
}

/** Scoped @material-ui/core stylesheet */
const useStyles = makeStyles<
  Theme,
  { isDragActive: boolean; error: Error | undefined }
>(theme => ({
  imageUploadDropZone: {
    border: "1px dashed",
    borderColor: ({ isDragActive, error }) =>
      error
        ? theme.palette.error.main
        : isDragActive
        ? theme.palette.secondary.main
        : theme.palette.type === "dark"
        ? theme.palette.grey[400]
        : theme.palette.grey[300],
    borderRadius: theme.shape.borderRadius,
    transition: theme.transitions.create("border-color"),
    height: theme.spacing(15),
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    "& .MuiTypography-root": { textTransform: "none" },
  },
}))

export const DragDropArea: FunctionComponent<DragDropAreaProps> = ({
  error,
  onDrop,
  dragActiveText = "Drop now!",
  dragInactiveText = "Drag & drop files here",
  ...props
}) => {
  /** Get the root and input props */
  const { getRootProps, isDragActive } = useDropzone({
    onDrop,
    ...props,
  })

  /** Get scoped CSS classes */
  const classes = useStyles({ isDragActive, error })

  return (
    <Box {...getRootProps({ className: classes.imageUploadDropZone })}>
      <GetAppRoundedIcon />
      <Typography variant="button">
        {isDragActive ? dragActiveText : dragInactiveText}
      </Typography>
    </Box>
  )
}
